import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const calculateQuote = async (payload) => {
    const { data } = await axios.post(API_ROUTES.CALCULATE, payload);
    return data;
};